import React from 'react';
import styled from 'styled-components';
import { string,} from 'prop-types';

const Wrapper = styled.span`
    position : relative;
        &::after{
            font-size :  ${({fontSize})=>fontSize && fontSize};
            position : absolute;
            top : ${({top})=>top && top};
            right : ${({right})=>right && right};
            left : ${({left})=>left && left};
            content : ${({caption})=>caption && `"${caption}"`};
        }
`;

function Caption({
	caption,
	fontSize='0.5rem',
	top='-70%',
	right='0',
	left,
	...props}){
	const {children} = props;
	return (
		<Wrapper 
			fontSize={fontSize} 
			caption={caption}
			top={top} 
			right={right}
			left={left}
			{...props}>{children}
		</Wrapper>);
}

function WithCaption(captionProps){
	return function CaptionedComponent(Component){
		return function CaptionedComponent2({caption,...props}){
			return <Caption caption={caption} {...captionProps}>
				<Component {...props}/>
			</Caption>;
		};
	};
}

export {WithCaption};
Caption.propTypes = {
	caption: string,
};

export default Caption;